import React from "react";
import PropTypes from "prop-types";

// Styles
import "./default-modal.styles.scss";

const BasicModal = ({
  title,
  children,
  setShowModal,
  onClose = () => {},
  width = "80%",
  height = "auto",
  handleCloseButton = () => {}
}) => {
  const closeModal = () => {
    if (setShowModal) {
      setShowModal(false);
      onClose();
      return;
    }
    handleCloseButton();
  };

  return (
    <div
      className="app__modal--basic-wrapper backdrop"
      role="dialog"
      aria-modal="true"
      data-name="modal_wrapper"
      aria-label={title}
      onClick={e => {
        if (!setShowModal) {
          return;
        }
        e.stopPropagation();
        if (e.target.getAttribute("data-name") === "modal_wrapper") {
          closeModal();
        }
      }}
    >
      <div className="app__modal--basic-container" style={{ width, height }}>
        {/* Close button */}
        <div className="app__modal--basic-close-container">
          {title ? <h4>{title}</h4> : null}
          <i
            className="fas fa-times app__modal--basic-close cp"
            onClick={closeModal}
          ></i>
        </div>

        <div className="app_modal--basic-content w-100">{children}</div>
      </div>
    </div>
  );
};

BasicModal.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  setShowModal: PropTypes.func,
  onClose: PropTypes.func,
  height: PropTypes.string,
  width: PropTypes.string,
  onClick: PropTypes.func,
};

export default BasicModal;
